import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/products.php';

export function getProducts(filters = {}) {
    // Remove filtros vazios antes de enviar
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;
    
    const response = api.get(url);

    return response;
};

export function getProductDetails(id) {

    const response = api.get(`${service_path}?id=${id}`);

    return response;
};

export function createProduct(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Produto criado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateProduct(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Produto editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteProduct(id, user_id) {

    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;

            if (data.success) {
                globalToast.success("Produto deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar esse produto!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};